//@ts-nocheck
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import formatCurrency from "../../utils/formatCurrency";

interface InputStandardProps {
  label: string;
  type?: string;
  handleChange?: any;
  onKeyDown?: any;
  value?: any;
  name?: string;
  search?: boolean;
  rows?: number;
  multiline?: boolean;
  disabled?: boolean;
  mask?: string;
  variant?: string;
  id?: any;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#F9B233",
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          width: "100%",
        },
      },
    },
  },
});

const InputStandard = ({
  label,
  type,
  handleChange,
  value,
  name,
  search,
  rows,
  multiline,
  disabled,
  mask,
  onKeyDown,
  variant,
  id,
}: InputStandardProps) => {
  const [valueAtt, setValueAtt] = useState(value || "");

  // Sincroniza o state interno quando o value externo mudar
  useEffect(() => {
    if (value !== undefined && value !== valueAtt) {
      setValueAtt(value);
    }
  }, [value]);

  const handleChangeAtt = (e: any) => {
    let newValue;
    if (type === "currency") {
      newValue = formatCurrency(e.target.value);
    } else {
      newValue = e.target.value;
    }
    setValueAtt(newValue);
    // Propaga para o pai imediatamente (resolve o problema do autocomplete)
    if (handleChange) {
      handleChange(newValue, name);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <InputMask
        onKeyDown={onKeyDown}
        style={{ width: "100%" }}
        mask={mask || ""}
        onChange={search ? handleChange : handleChangeAtt}
        name={name}
        value={search ? value : valueAtt}
        disabled={disabled}
      >
        <TextField
          variant={variant ? variant : "outlined"}
          type={type || "text"}
          rows={rows}
          multiline={multiline}
          key={label}
          id={id || "demo-helper-text-misaligned"}
          label={label}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "5px",
              backgroundColor: "#FFF",
            },
            "& .MuiInput-underline:before": {
              borderBottomColor: "#e0e0e0",
            },
            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
              borderBottomColor: "#F9B233",
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#F9B233",
            },
            "& input[type=number]": {
              MozAppearance: "textfield",
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
              {
                WebkitAppearance: "none",
                margin: 0,
              },
          }}
        />
      </InputMask>
    </ThemeProvider>
  );
};

export default InputStandard;
